export const GET_RECIPES = "GET_RECIPES";
export const SET_LOADING = "SET_LOADING";
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const USER_ERROR = "USER_ERROR";
export const ADD_RECIPE = "ADD_RECIPE";
export const RECIPE_ERROR = "RECIPE_ERROR";
